import React from "react";
import { ReactComponent as LampSvg } from "../svg/lamp.svg";

export default function LampIcon({ size = 64, color = "#32363F", ...props }) {
  return <LampSvg width={size} height={size} style={{ color }} {...props} />;
}
